import { db } from "@/firebase";
import {
  getDocs,
  collection,
  addDoc,
  updateDoc,
  doc,
  orderBy,
} from "firebase/firestore";

const support = {
  state: {
    tickets: [],
  },
  mutations: {
    setTickets(state, val) {
      state.tickets = val;
    },
  },
  actions: {
    async sendMessage({ rootState, dispatch }, val) {
      console.log("sendMessage", val);
      const docRef = await addDoc(
        collection(
          db,
          "users",
          rootState.users.userProfile.uid,
          "tickets",
          val.uid,
          "messages"
        ),
        {
          content: val.message,
          role: "user",
          created_at: Math.floor(Date.now() / 1000),
          created_by: rootState.users.userProfile.uid,
        }
      );
      await updateDoc(docRef, {
        uid: docRef.id,
      });
      dispatch("fetchTickets");
    },
    async addTicket({ commit, rootState, dispatch }, val) {
      commit("setLoading", { type: "support", val: true });
      const docRef = await addDoc(
        collection(db, "users", rootState.users.userProfile.uid, "tickets"),
        {
          ...val,
          created_at: Math.floor(Date.now() / 1000),
          user: rootState.users.userProfile.uid,
          status: "open",
          workspace: rootState.users.userProfile.workspace,
        }
      );
      await updateDoc(
        doc(db, "users", rootState.users.userProfile.uid, "tickets", docRef.id),
        {
          uid: docRef.id,
        }
      );

      const messageRef = await addDoc(
        collection(
          db,
          "users",
          rootState.users.userProfile.uid,
          "tickets",
          docRef.id,
          "messages"
        ),
        {
          content: val.description,
          role: "user",
          created_at: Math.floor(Date.now() / 1000),
          created_by: rootState.users.userProfile.uid,
        }
      );

      await updateDoc(messageRef, {
        uid: messageRef.id,
      });

      dispatch("fetchTickets");

      commit("setLoading", { type: "support", val: false });
    },
    async fetchTickets({ commit, rootState }) {
      let list = [];

      const tickets = await getDocs(
        collection(db, "users", rootState.users.userProfile.uid, "tickets"),
        orderBy("created_at", "desc")
      );

      list = await Promise.all(
        tickets.docs.map(async (doc) => {
          let t = doc.data();
          t.messages = [];
          const messages = await getDocs(
            collection(
              db,
              "users",
              rootState.users.userProfile.uid,
              "tickets",
              doc.id,
              "messages"
            )
          );
          messages.docs.map((m) => {
            t.messages.push(m.data());
          });
          t.messages.sort((a, b) => b.created_at - a.created_at);
          return t;
        })
      );
      list.sort((a, b) => b.created_at - a.created_at);

      commit("setTickets", list);
    },
    async closeTicket({ commit, rootState, state }, uid) {
      await updateDoc(
        doc(db, "users", rootState.users.userProfile.uid, "tickets", uid),
        {
          status: "closed",
        }
      );
      commit(
        "setTickets",
        state.tickets.map((t) =>
          t.uid === uid ? { ...t, status: "closed" } : t
        )
      );
    },
  },
  getters: {},
};

export default support;
